import React from 'react';
import { DateFormat, transformDateTimeFormatPST } from '@scale/shared/utils/dateUtils';

interface TimeFormatterProps {
  value: Date;
}

const TimeFormatter: React.FC<TimeFormatterProps> = ({ value }) => {
  return (
    <div className="formatter formatter--text formatter--time">
      {value ? transformDateTimeFormatPST(value, DateFormat.condensed) : null}
    </div>
  );
};

export default TimeFormatter;
